import * as React from "react";

import * as dates from "../../../reducers/changeTimePeriod";

export interface IDateHeadingProps {
    currentDate: Date;
}

export const DateHeading = (props: IDateHeadingProps) => {

    const dateDesc = dates.formatDaynameMonthYear(props.currentDate);

    return (
      <div className="CAL-daysOfWeek" aria-hidden="true">
        <ul>
          <li>{dateDesc}</li>
        </ul>
      </div>
    );
};
